import { ContentTypeFilterClause, MixedContentItemDefinition, SpaceDefinition } from './ContentDefinitionsTypes';
import { Messages } from '../../../codegen/Localize';
import { FlowContentType } from '../ContentTypes';
import { getGenericDefaultFilters } from './getDefaultFilters';
import { FlowCard } from '../../../app/spaces/CardView/FlowCard';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { ServerFilterClauses } from '../../helpers/ServerFilterClauses';
import { SpacesSiteUrls } from '../../../app/spaces/SpacesSiteUrls';
import { Flows } from '../../resources/Flows';

export const FlowDefinition: MixedContentItemDefinition & SpaceDefinition<'flow'> = {
  itemType: 'flow',
  contentType: 'flow',
  singularName: Messages.flow,
  pluralName: Messages.flows,
  emptyStateMessage: Messages.flowsEmptyMessage,
  siteFilterByTypeDropdownName: Messages.siteFilterByTypeDropdown_Flows,
  contentFilterKeys: FlowContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: FlowCard,
  listViewIconUrl: imgPath('flow_18px-large.svg'),
  filterClause: ServerFilterClauses.ContentType(['flow']) as ContentTypeFilterClause,
  contentSpaceUrl: (urls: SpacesSiteUrls, contentId: string) => urls.flowUrl(contentId),
  getBasicQuery: () => {
    return Flows.all().withExtraParams(FlowContentType.extraQueryParams);
  },
  fieldValueResourceType: 'flow',
  getContentInfo: () => {
    throw new Error('getContentInfo is not implemented for flow');
  },
  headerIconPath: () => imgPath('spaces_masthead_flow.svg'),
  supportedDisplayModes: ['list', 'thumbnail'],
};
